import { loadMessages } from './loadMessages';
import { LocalizationProvider, LocalizationProviderVue3 } from './LocalizationProvider';
import { LocalizationService } from './LocalizationService';
export { loadMessages, LocalizationProvider, LocalizationProviderVue3, LocalizationService };
// Automatic installation if Vue has been added to the global scope.
var vue = 'Vue';
if (typeof window !== 'undefined' && window[vue] && window[vue].component) {
    window[vue].component('kendo-localization-provider', LocalizationProvider);
}
